import Joi from "joi-browser";

const UpdateSuppliersSchema = Joi.object().keys({
    name: Joi.string().trim().max(256).min(3).required().label("Name"),
    codeName: Joi.string()
        .regex(/^[a-zA-Z\d-_]+$/)
        .trim()
        .max(20)
        .min(2)
        .allow(null)
        .allow("")
        .optional()
        .label("Code Name")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                if (err.type === "string.regex.base") {
                    return "should only contain letters, numbers, hyphens or underscores.";
                }
                if (err.type === "string.min") {
                    return "length must be at least 2 characters long.";
                }
                if (err.type === "string.max") {
                    return "length must be less than or equal to 20 characters long";
                } else return;
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    materials: Joi.array().min(1).required().label("Materials"),
    supportedCountry: Joi.object().required().label("Country"),
    description: Joi.string()
        .allow("")
        .allow(null)
        .trim()
        .max(256)
        .label("Description"),
    city: Joi.string().allow("").allow(null).trim().label("City"),
    state: Joi.string().allow("").allow(null).trim().label("State"),
});

export default {
    UpdateSuppliersSchema,
};
